import React, { useState,useRef, useEffect } from "react";


import makeStyles from "@material-ui/core/styles/makeStyles";

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import styles from "assets/jss/material-kit-react/components/leaderBoard.js";

import Config from "../../config.js"
import Axios from "axios";
import swal from 'sweetalert'



const useStyles = makeStyles(styles);

function Row(props) {
  const { row,index,teamName } = props;
  const classes = useStyles();
  if(row.name==teamName)
  row.mine=true
  return (
   <TableRow  className={classes.RightToLeft} key={row.name}>

              <TableCell className={classes.RightToLeft+" "+classes.Center+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')} component="th" scope="row">
                {index+1}
              </TableCell>
              <TableCell className={classes.RightToLeft+" "+classes.Center+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')}>{row.name}</TableCell>
              <TableCell className={classes.RightToLeft+" "+classes.Center+" "+classes.Row+ ((row.mine)?' '+classes.Mine:'')}>{row.score}</TableCell>
    </TableRow>
  );
}






const LeaderBoard = React.forwardRef((props, ref) => {
    const {
        refresh , 
        challengeId,
        teamName,
        address='ICTChallenge',
        ...rest
    } = props;
    const classes = useStyles();

    useEffect(() => {
        GetData(challengeId);
    },[refresh]);
    const [board, setBoard] = React.useState(null);

    const GetData = (cid) => {
        Axios.post(Config.api + address+"/LeaderBoard", {
        },
            {
                headers: {
                    apikey: Config.apikey,
                    Authorization: "Bearer " + localStorage.getItem('token')

                }
            }).then(async (result) => {
                setBoard(result.data.data)
            }).catch((err) => {
                if (err&&err.response&&err.response.status&&err.response.status === 401) {
                    localStorage.removeItem('token');
                    props.history.push("/SignIn");
                }
                else if (err&&err.response&&err.response.status&&err.response.status === 422)
                    console.log("اطلاعات ارسالی نادرست است.")
                else if (err&&err.response&&err.response.data&&err.response.data.message&&err.response.data.message.pr) {
                    swal(err.response.data.message.pr);
                }
                else
                console.log("خطایی رخ داده است.")
            })
    }
    
      return (
           <TableContainer >
      <Table aria-label="collapsible table">
        <TableHead>
          <TableRow>
                <TableCell>#</TableCell>
                <TableCell  align="center">نام تیم</TableCell>
                <TableCell align="center">امتیاز</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {board && board.map((row,index) => (
            <Row index={index} key={row._id} row={row} teamName={teamName} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
      );
});


export default LeaderBoard;
